export const rowStyles = () => `
  display: flex;
   
  > :first-child {
    width: 70%;
  }
  
   > :nth-child(2) {
    width: 30%
   }
`;
